module.exports = "/_next/static/images/WebThirdIntroduce-89614f8eb278fb446387f2b15c91d437.png";